var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "lds-wave",
      class: _vm.className,
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
      },
    },
    [
      _c(
        "circle",
        { attrs: { cx: "11", cy: "38.086", r: _vm.radius, fill: "#e15b64" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "0s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "22", cy: "56.4712", r: _vm.radius, fill: "#f47e60" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.125s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "33", cy: "68.3092", r: _vm.radius, fill: "#f8b26a" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.25s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "44", cy: "69.6081", r: _vm.radius, fill: "#abbd81" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.375s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "55", cy: "61.914", r: _vm.radius, fill: "#e15b64" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.5s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "66", cy: "43.5288", r: _vm.radius, fill: "#f47e60" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.625s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "77", cy: "31.6908", r: _vm.radius, fill: "#f8b26a" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.75s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "88", cy: "30.3919", r: _vm.radius, fill: "#abbd81" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              values: "30;70;30",
              times: "0;0.5;1",
              dur: "1s",
              calcMode: "spline",
              keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
              begin: "-0.875s",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }